import { FC } from 'react';
import { useState } from 'react';
import { SectionsOrgResponse } from '../../api/fetchSectionOrgs';
import { SectionsProps } from './Sections.type';
import { Sections } from './SectionsByName';

type HoverLink = SectionsProps['hoverLink'] | null;

interface Props {
    orgSections: SectionsOrgResponse;
}

export const SectionsContainer: FC<Props> = ({ orgSections }) => {
    const [hoverLink, setHoverLink] = useState<HoverLink>(null);

    return (
        <Sections
            hoverLink={hoverLink}
            handleHoverLink={setHoverLink}
            orgSections={orgSections}
        />
    );
};
